// extracted by mini-css-extract-plugin
export default {"main":"App_main__CoaW+","wrapper":"App_wrapper__LjqNF"};